import React from "react";
import {View, StyleSheet} from "react-native";
import PtText from "../core/pt-text/pt-text";
import {styleVars} from "../../app-style-vars";
import {getTranslation} from "../../helpers/getTranslation";

export default function PtDuePaymentStatusIndicator(props:any) {

  const statusCode = props.statusCode;
  const statusText = getTranslation(`due.payments.status.${statusCode}`);

  const indicatorColor = () => {
    switch (statusCode) {
      case 'overdue': { return styleVars.boschRed }
      case 'due': {return styleVars.boschLightGreen}

      default: return styleVars.boschLightGray
    }
  }


  const styles = StyleSheet.create({
    orderStatusIndicatorContainer: {
      flex: 1,
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
    },
    duePaymentStatusIndicator: {
      width: styleVars.rem(.75),
      height: styleVars.rem(.75),
      borderRadius: styleVars.rem(.375),
      backgroundColor: indicatorColor(),
    },
    duePaymentStatusIndicatorTextContainer: {
      paddingLeft: styleVars.rem(.5),
    },
    duePaymentStatusIndicatorText: {
      fontSize: styleVars.rem(.75),
      color: indicatorColor()
    }
  });


  return (
    <View style={[styles.orderStatusIndicatorContainer]}>
      <View style={[styles.duePaymentStatusIndicator, indicatorColor]}></View>
      <View style={[styles.duePaymentStatusIndicatorTextContainer]}>
        <PtText style={[styles.duePaymentStatusIndicatorText]}>
          {statusText}
        </PtText>
      </View>
    </View>
  )
}